import React from "react";
import { makeStyles } from "@material-ui/core";
import Layout from "../../../layout";
import ContentRegister from './contentRegister/contentRegister';
import Videos from './videos/videos';

let useStyles = makeStyles((theme) => ({
    root: {
        width: '90%',
        margin: 'auto',
        padding: '20px ',
        '@media (max-width: 768px)': {
            width: '95%',
            margin: 'auto',
        },
        '@media (max-width: 500px)': {
            width: '100%',
            margin: 'auto',
        },
    },
}))

export default function Index() {

    let classes = useStyles();

    return (
        <Layout>
            <div className={classes['root']}>
                <Videos />
                <ContentRegister />
            </div>
        </Layout>
    )
}
